import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-827c97ea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 2,
  style: {
    "margin-top": "8px",
    "width": "100%",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_4 = {
  style: {
    "vertical-align": "middle",
    "min-width": "100px"
  }
};
const _hoisted_5 = {
  class: "dialog-footer"
};
import { useVModel, useDebounceFn } from '@vueuse/core';
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
import { saveSmsTemplate, updatePlatSmsTemplate, updateSmsTemplate } from '@/api/sms';
import { placeholderList } from '../config';
export default {
  __name: 'SmsModule',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    },
    appId: {
      type: String,
      required: true
    },
    formSchemas: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel', 'changeFormData'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const route = useRoute();
    const originFormData = {};
    const formData = ref({});
    const init = () => {
      props.formSchemas.forEach(item => {
        originFormData[item['field']] = item['defaultValue'];
      });
      originFormData.platform = route.query.platform || 1;
      formData.value = originFormData;
    };
    init();

    // 表单数据

    const resetForm = () => {
      formData.value = originFormData;
    };
    watch(() => props.model, val => {
      formData.value = originFormData;
      if (val) {
        formData.value = {
          id: val.id,
          ...JSON.parse(JSON.stringify(val))
        };
      } else {
        resetForm();
      }
    }, {
      deep: true,
      immediate: true
    });
    const emits = __emit;
    watch(formData, val => {
      if (val) {
        emits('changeFormData', val);
        // eslint-disable-next-line
        if (val.platform == 3) {
          console.log('formData.value.templateType:', formData.value.templateType);
          formData.value.templateType = 1;
          formData.value.remark = '';
        }
      }
    }, {
      immediate: true,
      deep: true
    });
    const isVisible = useVModel(props);
    const templateContentInputRef = ref(null);
    const getCaretPosition = inputElement => {
      const startPos = inputElement.selectionStart;
      // const endPos = inputElement.selectionEnd
      return parseInt(startPos);
    };
    const handleAddTemplateContent = item => {
      const position = getCaretPosition(templateContentInputRef.value[0].ref);
      if (position === 0) {
        formData.value.templateContent += '${' + item.value + '}';
      } else {
        const arr = formData.value.templateContent.split('');
        arr.splice(position, 0, '${' + item.value + '}');
        formData.value.templateContent = arr.join('');
      }
    };

    // 表单元素
    const formEl = ref(null);
    /**
     * 新增事件
     */
    const loading = ref(false);
    const handleAddNewData = useDebounceFn(async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          loading.value = true;
          try {
            if (!props.model) {
              await saveSmsTemplate({
                ...formData.value,
                appId: props.appId
              });
            } else {
              if (props.model.templateStatus === 1) {
                await updatePlatSmsTemplate({
                  ...formData.value
                });
              } else {
                await updateSmsTemplate(formData.value);
              }
            }
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
          } catch (error) {
            console.log(error);
          } finally {
            loading.value = false;
            isVisible.value = false;
          }
        } else {
          ElMessage({
            type: 'error',
            message: '验证失败'
          });
        }
      });
    }, 300);
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改模板' : '申请模板',
        width: "60%",
        onClosed: closed,
        class: "dialog-class",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(handleAddNewData),
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["onClick", "loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "180px",
          model: formData.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formSchemas, (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [item.component === 'Text' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: item.label
            }, {
              default: _withCtx(() => [item.field === 'isParams' ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(formData.value[item.field] == 1 ? '有变量参数' : '无变量参数'), 1)) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["label"])) : _createCommentVNode("", true), item.component === 'Input' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [item.field === 'paramsName' ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                disabled: item === null || item === void 0 ? void 0 : item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])) : item.field === 'isParams' ? (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                "model-value": formData.value[item.field] == 1 ? '有变量参数' : '无变量参数',
                placeholder: item.placeholder,
                disabled: item === null || item === void 0 ? void 0 : item.disabled
              }, null, 8, ["model-value", "placeholder", "disabled"])) : (_openBlock(), _createBlock(_component_el_input, {
                key: 2,
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                disabled: item === null || item === void 0 ? void 0 : item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"]))]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'InputTextArea' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [item.field !== 'templateContent' ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                type: "textarea",
                autosize: {
                  minRows: 5
                }
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                type: "textarea",
                autosize: {
                  minRows: 5
                },
                ref_for: true,
                ref_key: "templateContentInputRef",
                ref: templateContentInputRef
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])), item.field === 'templateContent' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(placeholderList), item => {
                return _openBlock(), _createElementBlock("div", {
                  key: item.type,
                  style: {
                    "display": "flex",
                    "align-items": "center",
                    "flex-wrap": "wrap"
                  }
                }, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.tip) + "：", 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (val, i) => {
                  return _openBlock(), _createElementBlock("div", {
                    key: i,
                    style: {
                      "display": "flex",
                      "align-items": "center",
                      "flex-wrap": "wrap"
                    }
                  }, [_createVNode(_component_el_tooltip, {
                    content: val.desc
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createBlock(_component_el_button, {
                      onClick: $event => handleAddTemplateContent(val),
                      key: item,
                      style: {
                        "margin-bottom": "6px",
                        "margin-right": "6px"
                      }
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(val.label), 1)]),
                      _: 2
                    }, 1032, ["onClick"]))]),
                    _: 2
                  }, 1032, ["content"])]);
                }), 128))]);
              }), 128))])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'Radio' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.radioArr, item => {
                  return _openBlock(), _createBlock(_component_el_radio_button, {
                    key: item.value,
                    label: item.value
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true)], 64);
          }), 128))]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};